import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigService } from '../../../services/app-config.service';

@Component({
  selector: 'payroll-wip-csr',
  templateUrl: './payroll-wip-csr.component.html',
  styleUrls: ['./payroll-wip-csr.component.css'],
  standalone: false
})
export class PayrollWipCSRComponent implements OnInit {
  constructor(
    private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {}

  // #region Public methods

  public getSrc() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfigService.getConfig().ExternalReports['Payroll WIP CSR']
    );
  }

  // #endregion Public methods
}
